import moment from 'moment';

/** Returns fresh date presets - call at render time so Today/Yesterday reflect current date */
export function getAdminDatePresets() {
  return {
    Today: [moment().startOf('day'), moment().endOf('day')],
    Yesterday: [moment().subtract(1, 'days').startOf('day'), moment().subtract(1, 'days').endOf('day')],
    'This Week': [moment().startOf('week'), moment().endOf('week')],
    'This Month': [moment().startOf('month'), moment().endOf('month')],
  };
}

export function getCurrentWeekRange() {
  return [moment().startOf('week'), moment().endOf('week')];
}
